import { render } from "./404Page.vue?vue&type=template&id=0909f5b9&scoped=true&ts=true"
import script from "./404Page.vue?vue&type=script&lang=ts"
export * from "./404Page.vue?vue&type=script&lang=ts"

import "./404Page.vue?vue&type=style&index=0&id=0909f5b9&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0909f5b9"]])

export default __exports__